:host {
  --cms-article-image-ratio: var(--cms-article-image-ratio, auto);
  display: block;
  position: relative;
  justify-content: space-between;
  cursor: pointer;
  flex: 100%;
  height: 100%;
}

.article-info-container {
  padding: var(--cms-spacing-075);
  text-decoration: none;
  display: block;
  position: relative;
  flex: 100%;
  max-width: 100%;
  box-sizing: border-box;
  height: 100%;

  &:hover .target-name {
    --cms-link-decoration: underline;
  }
}

.article-info-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);


  --cms-article-data-grid-area: var(--cms-article-data-grid-area-override, auto / auto / auto / span 6);
  --cms-article-image-grid-area: var(--cms-article-image-grid-area-override, auto / auto / auto / span 6);
  --cms-article-grid-gap: var(--cms-article-grid-gap-override, var(--cms-spacing-200));
  --cms-article-grid-padding: var(--cms-article-grid-padding-override, var(--cms-spacing-100));
}

.target-name {
  position: relative;
  z-index: 5;
  margin-top: auto;
}

.teaser-content-inner.article:hover .target-name {
  --cms-link-decoration: underline;
}



cms-article-name {
  text-decoration: none;
  color: var(--cms-theme-text-color);
}

.cta,
.cta:hover,
.cta:visited {
  text-decoration: none;
}

.cta::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: auto;
  border: none;
  background: none;
  content: "";
}

.cta:focus,
.cta:focus-visible {
  outline: none;
}

.cta:focus::after {
  box-shadow: inset 0 0 0 0.25rem var(--cms-semanticColors-container-focus-outlineOuter),
    inset 0 0 0 0.125rem var(--cms-semanticColors-container-focus-outlineInner);
  border-radius: var(--cms-border-radius-xs);
  outline: none;
}

.article-name {
  color: var(--cms-semanticColors-base-strong-text);
}

.article-data-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.article-image-wrapper {
  margin: 0 auto var(--cms-spacing-075) auto;
}

.article-image {
  aspect-ratio: var(--cms-article-image-ratio);
  object-fit: contain;
}

cms-price {
  margin-bottom: var(--cms-spacing-100);
  padding-bottom: 0;
}

cms-energy-label {
  position: relative;
  z-index: 5;
}

@media (min-width: 768px) {
  .article-info-wrapper.horizontal {
    display: grid;
    height: var(--cms-grid-row-height);
    max-width: var(--cms-container-max-width);
    grid-template-columns: var(--cms-grid-template-columns);
    padding: var(--cms-article-grid-padding);
    gap: var(--cms-article-grid-gap);

    .article-data-container {
      grid-area: var(--cms-article-data-grid-area);
    }

    .article-image-wrapper {
      grid-area: var(--cms-article-image-grid-area);
    }
  }
}

cms-button {
  --cms-theme-border-color: var(--cms-semanticColors-base-strong-border);
}

@media (any-hover: hover) {

  :host(:hover) cms-button,
  .article-info-container:hover cms-button:hover {
    --cms-button-background-color: var(--cms-semanticColors-transparency-strong-hover-background);

  }
}